<template>
  <div class="my-org">
    <ep-title title="单位列表">
      <el-button type="primary" size="small" @click='changeCompany'> 切换单位 </el-button>
      <el-button type="primary" size="small" @click="toAddOrg"> 添加 </el-button>
    </ep-title>
    <el-table :data="datalist" align="left" highlight-current-row @row-click="searchDetail" style="width:100%;margin-top:10px">
      <el-table-column type="index" label="序号" width="80" align="center">
      </el-table-column>
      <el-table-column label="单位类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type==0">企事业单位</span>
          <span v-if="scope.row.type==1">政府单位</span>
          <span v-if="scope.row.type==2">工业园区</span>
          <span v-if="scope.row.type==3">饮用水源地</span>
          <!-- <span v-if="scope.row.type==4">其它</span> -->
        </template>
      </el-table-column>
      <el-table-column label="单位名称" prop="name" align="center">
      </el-table-column>
      <el-table-column label="id" align="center">
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>
      <el-table-column label="所在区县" align="center">
        <template slot-scope="scope">
          {{getCountys(scope.row.regions)}}
        </template>
      </el-table-column>
      <el-table-column label="所在市" align="center">
        <template slot-scope="scope">
          {{ getCitys(scope.row.regions) }}
        </template>
      </el-table-column>
      <el-table-column label="成员数量" align="center" prop="count">
      </el-table-column>
      <el-table-column label="我的角色" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.role==1">管理员</span>
          <span v-if="scope.row.role==2">普通用户</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{formatTime(scope.row.createtime)}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="panel-footer">
      <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-size="pageSize" :page-sizes="[12, 25, 50]" :current-page="currentPage" layout="total,sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="单位类型" v-model="selectShow" size="tiny">
      <p class="m-p">报单位类型一旦选择无法更改，请仔细阅读说明后选择</p>
      <div class="m-radio">
        <el-radio-group v-model="radio2" @change="radioChange">
          <el-radio label="0" :disabled="isTypeDisabled('0')">企事业单位（企业、工厂、事业单位）</el-radio>
          <el-radio label="1" :disabled="isTypeDisabled('1')">政府</el-radio>
          <el-radio label="2" :disabled="isTypeDisabled('2')">工业园区</el-radio>
          <el-radio label="3" :disabled="isTypeDisabled('3')">饮用水源地保护区</el-radio>
          <!-- <el-radio label="4">其它</el-radio> -->
        </el-radio-group>
        <p v-if="limitHint" class="limit-hint">{{ limitHint }}</p>
      </div>
      <el-row>
        <br>
        <span style="color: #20a0ff;">{{tip}}</span>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="selectShow = false">取 消</el-button>
        <el-button type="primary" @click="selectShowdiv">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="切换申报单位" :visible.sync="dialogVisible" size="tiny">
      <div style="height:200px; overflow-y:auto" class="content-box">
        <ul class="content-con">
          <li v-for="(item,index) in detail"
              @click="liclick(item,index)" :key="index">
            <a :class="{active : selectIndex === index}">{{item.value}}</a>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click='changeSure'>确定</el-button>
		  </span>
    </el-dialog>
  </div>
</template>
<script>
import company from '../../data/basic/plan/company.js'
import { normalizeCountByType, isTypeAtLimit, limitMessage } from '../../data/basic/plan/unitLimit.js'
import moment from 'moment'
import { Bus } from './bus.js'
import { mapState, mapMutations } from 'vuex'

let tipArray = ['说明: 由企业、工厂、事业单位选择，绝大多数申报单位都属于此类型',
    '说明: 政府类型仅限提交政府应急预案的政府单位选择；如申报事业单位的应急预案，请选企事业单位类型',
    '说明: 工业园区仅限由政府设立，由园区管委会管理的园区选择；如只是提交工厂厂区的应急预案，请选企事业单位类型','']

export default {


  data() {
    return {
      datalist: [],
      showAddUnit: false,
      // 选择机构类型
      selectShow: false,
      radio2: '0',
      vals: '',
      currentPage: 1,
      total: 0,
      pageSize: 12,
      detail: [],
      dialogVisible: false,
      currentSelCompony: null,
      selectIndex: -1,
      tip:tipArray[0],
      countByType: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 },

    }
  },
  computed: {
    ...mapState({
      showlistState(state) {
        return state.showlistState
      }
    }),
    limitHint() {
      if (isTypeAtLimit(this.countByType, this.radio2)) {
        return limitMessage(this.radio2)
      }
      return ''
    }
  },
    // watch:{
    //     radio2(val){
    //       console.log(val,'radio2')
    //   }
    // },
  created() {
    this.getData({
      size: this.pageSize,
      page: this.currentPage - 1,
      isClient: true
    })
    let showAddUnit = this.$route.query.showAddUnit;
    this.showAddUnit = !showAddUnit ? false : true;
    if (!this.showlistState) return
    this.selectShow = this.showlistState
  },
  watch: {
    $route: {
      handler() {
        let showAddUnit = this.$route.query.showAddUnit;
        this.showAddUnit = !showAddUnit ? false : true;
      },
      deep: true,
    },
    selectShow(val) {
      if (val) {
        this.fetchCountByType()
      }
    }
  },
  methods: {
    ...mapMutations(['changeCurrUid', 'changeCurVal', 'setNameList', 'showlist', 'getNameList', 'changeIsRendering', 'setCurrentComponyName']),
    changeRadio(val){
        // console.log(change)
    },
      radioChange(val){
        this.tip = tipArray[val];
      },
      // 格式化城市
    getCitys(city) {
      if (!city) {
        return
      }
      let cityName = ''
      for (let i = 0; i < city.length; i++) {
        cityName += city[i].city.name + '、'
      }
      return cityName.substring(0, cityName.length - 1)
    },
    // 格式化区县
    getCountys(county) {
      let countyname = ''
      if (!county) {
        return
      }
      for (let i = 0; i < county.length; i++) {
        for (let j = 0; j < county[i].county.length; j++) {
          countyname += county[i].county[j].name + '、'
        }
      }
      return countyname.substring(0, countyname.length - 1)
    },
    // 获取单位列表
    getData(params) {
      (async() => {
        let getState = await company.get_list(params)
        if (getState.status) {
          this.datalist = getState.data.content

          if (this.datalist.length === 1) {
            let namalist = []
            for (let i = 0; i < this.datalist.length; i++) {
              namalist.push({
                value: this.datalist[i].name,
                id: this.datalist[i].id,
                type: this.datalist[i].type
              })
            }
            sessionStorage.itemName = JSON.stringify(namalist[0])
            this.changeIsRendering(namalist[0].type)
            this.setCurrentComponyName(namalist[0])
            sessionStorage.itemNamea = JSON.stringify(namalist)
            this.getNameList(JSON.stringify(namalist))
          }

          this.total = getState.data.totalElements
          this.pageSize = getState.data.size
          this.updateUnitName()
        } else {
          this.$message.error('机构查询接口异常，请稍候重试')
        }
      })()
    },
    // 更新单位名称列表
    updateUnitName() {
      (async() => {
        let getState = await company.get_searchlist()
        if (getState.status) {
          let datalist = getState.data
          if (!Array.isArray(datalist)) return
          let namalist = []
          for (let i = 0; i < datalist.length; i++) {
            namalist.push({
              value: datalist[i].name,
              id: datalist[i].id,
              type: datalist[i].type
            })
          }
          this.setNameList(namalist)
        } else {
          this.$message.error('机构查询接口异常，请稍候重试')
        }
      })()
    },
    // 格式化时间
    formatTime(time) {
      return moment(time).format('YYYY/MM/DD HH:mm:ss')
    },
    async fetchCountByType() {
      let getState = await company.get_member_count_by_type()
      if (!getState.status) {
        this.$message.error(getState.msg || '单位数量查询失败，请稍候重试')
        return false
      }
      this.countByType = normalizeCountByType(getState.data)
      return true
    },
    isTypeDisabled(type) {
      return isTypeAtLimit(this.countByType, type)
    },
    // 跳转至新增单位
    async toAddOrg() {
      const ok = await this.fetchCountByType()
      if (!ok) return
      this.selectShow = true
    },
    // 查看单位详情
    searchDetail(val) {
      sessionStorage.orgStatus = JSON.parse(JSON.stringify(val.type))
      sessionStorage.currenOrgId = val.id
      sessionStorage.currenOrgval = JSON.stringify(val)
      // sessionStorage.currenphone = val.phone
      // 类型
      sessionStorage.currenrole = val.role
      this.changeCurrUid({
        uid: val.id,
        type: val.type
      })
      this.changeCurVal(val)
      this.$router.push('/unitdetail')
    },
    //
    async selectShowdiv() {
      const ok = await this.fetchCountByType()
      if (!ok) return
      if (isTypeAtLimit(this.countByType, this.radio2)) {
        this.$message.warning(limitMessage(this.radio2))
        return
      }
      sessionStorage.orgStatuID = this.radio2
      this.$router.push('/Addunit')
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData({
        size: this.pageSize,
        page: this.currentPage - 1
      })
    },
    // 显示的条数
    handleSizeChange(val) {
      this.getData({
        size: val
      })
    },
    getSwitchData() {
        (async() => {
            let getState = await company.get_searchlist()
            if(getState.status) {
                let namalist = []
                let datalist = getState.data
                for(let i = 0; i < datalist.length; i++) {
                    namalist.push({
                        value: datalist[i].name,
                        id: datalist[i].id,
                        type: datalist[i].type
                    })
                }
                this.detail = namalist
                sessionStorage.itemNamea = JSON.stringify(namalist)
            } else {
                this.$message.error(getState.msg)
            }
        })()
    },

    //确定切换单位
    liclick(item, index) {
        this.currentSelCompony = item
        this.selectIndex = index
        sessionStorage.orgStatus = JSON.parse(JSON.stringify(item.type))
        // added by aimee
        sessionStorage.currently = JSON.stringify(item)
    },
    changeSure() {
        if(!this.currentSelCompony) {
            this.$message.error('请选择申报单位')
            return
        }
        sessionStorage.itemName = JSON.stringify(this.currentSelCompony)
        // console.log(this.currentSelCompony,'currentSelCompony')
        this.setCurrentComponyName(this.currentSelCompony)
        this.changeIsRendering(this.currentSelCompony.type)
        this.$router.push('/')
    },
    // 切换单位弹窗展示
    changeCompany() {
        // console.log(sessionStorage.currenOrgId,'currentOrgId')
        this.dialogVisible = true
        this.getSwitchData();
    },
  },
  beforeDestroy() {
    this.showlist(false)
  },
}

</script>
<style lang="stylus" scoped>
.el-dialog__header {
  padding: 0
}

.m-p {
  margin-bottom: 30px;
}

.m-radio {
  border-bottom: solid 1px #ccc;
}

.limit-hint {
  margin-top: 12px;
  color: #f56c6c;
  font-size: 13px;
}

.panel-footer {
  margin: 20px 20px 0 0;
  text-align: right;
}

.el-radio-group>label {
  display: block;
  margin-bottom: 20px;
}

.el-radio-group>label:first-child {
  margin-left: 15px;
}

.el-radio__label {
  padding-left: 20px;
}

.el-radio-group>label>span {
  margin-right: 30px;
}

.content-box {
  margin-top: -50px;
  li {
    list-style: none;
    height: 35px;
    line-height: 35px;
    width: 100%;
    font-size: 14px;
    cursor: pointer;
    list-style-type: none;
    a {
      text-indent: 10px;
      width: 100%;
      height: 100%;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: all .5s;
      &:hover,
      &.active {
        border-radius: 5px;
        width: 100%;
        background: rgba(0, 0, 0, .2);
        height: 100%;
        color: #000;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// myunit.vue?33cb9d37